import React, { useEffect } from 'react';
import { createRoot } from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import moment from "moment";
import { useIsMounted } from 'usehooks-ts';
import { parse_url } from '../../../common/src';
import { TYPE_SCHEDULE } from '../../../platform/src/constants/widget-types';
import { EventContextProvider } from '../../../platform/src/context/EventContext';
import { LocaleContextProvider } from '../../../platform/src/context/LocaleContext';
import { PlayerContextProvider } from '../../../platform/src/context/PlayerContext';
import { StreamContextProvider } from '../../../platform/src/context/StreamContext';
import { UserContextProvider } from '../../../platform/src/context/UserContext';
import { ApplicationContextProvider } from '../../../platform/src/context/ApplicationContext';
import { WidgetContextProvider } from '../../../platform/src/context/WidgetContextProvider';
import { QuestionsContextProvider } from '../../../platform/src/context/QuestionsContext';
import { NotificationsContextProvider } from '../../../platform/src/context/NotificationsContext';
import { ModalContextProvider } from '../../../platform/src/context/ModalContext';
import WidgetView from './view/WidgetView';

moment.locale('ru');

import './style.scss';

const Widget = ({ watchKey, widgetKey }) => (
    <EventContextProvider watchKey={watchKey}>
        <StreamContextProvider>
            <NotificationsContextProvider>
                <UserContextProvider hasAuth={false}>
                    <ApplicationContextProvider>
                        <QuestionsContextProvider>
                            <ModalContextProvider>
                                <WidgetView widgetKey={widgetKey} />
                            </ModalContextProvider>
                        </QuestionsContextProvider>
                    </ApplicationContextProvider>
                </UserContextProvider>
            </NotificationsContextProvider>
        </StreamContextProvider>
    </EventContextProvider>
);

const App = () => {
    const request = parse_url(location.href);
    const watchKey = request?.segments?.[1];

    if (!watchKey) {
        return null;
    }

    const isMounted = useIsMounted();

    const checkHeight = () => {
        const height = window.document.body.offsetHeight;
        if (height !== window.innerHeight) {
            window.parent.postMessage({ setHeight: height }, '*');
        }
    };

    useEffect(() => {
        setInterval(checkHeight, 100);
        checkHeight();
    }, [isMounted]);

    return (
        <WidgetContextProvider isWidget widgetType={TYPE_SCHEDULE}>
            <LocaleContextProvider>
                <PlayerContextProvider>
                    <Widget
                        watchKey={watchKey}
                        widgetKey={request?.getParameter('widgetKey') ?? null}
                    />
                </PlayerContextProvider>
            </LocaleContextProvider>
        </WidgetContextProvider>
    );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);
